const currentURL = window.location.href;
const shareTitle = "Ich habe einen tollen Artikel im Ecotel Blog gefunden";

if (document.querySelectorAll('.postheader__share_social').length >= 1) {
  initSocialShare();
}

function initSocialShare() {
  document.querySelector('.postheader__share_social [data-social="xing"]').addEventListener("click", function (e) {
    const xingShareURL = `https://www.xing.com/app/user?op=share&url=${encodeURIComponent(currentURL)}`;
    window.open(xingShareURL);
  });

  document.querySelector('.postheader__share_social [data-social="facebook"]').addEventListener("click", function (e) {
    const facebookShareURL = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentURL)}`;
    window.open(facebookShareURL);
  });

  document.querySelector('.postheader__share_social [data-social="linkedin"]').addEventListener("click", function (e) {
    const linkedinShareURL = `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(currentURL)}&title=${encodeURIComponent(shareTitle)}`;
    window.open(linkedinShareURL);
  });

  document.querySelector('.postheader__share_social [data-social="mail"]').addEventListener("click", function (e) {
    e.preventDefault();
    const emailSubject = encodeURIComponent(shareTitle);
    const emailBody = encodeURIComponent(`${currentURL}`);
    const mailtoURL = `mailto:?subject=${emailSubject}&body=${emailBody}`;
    window.location.href = mailtoURL;
  });
}

